import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungs-typ-felder';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypFelderEffects {

    VeranstaltungsTypFelder$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGS_TYP_FELDER),
        mergeMap((x: ac.GetVeranstaltungsTypFelderAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungsTypFelder(x.veranstaltungstyp_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungsTypFelderErfolgreichAction(result, x.veranstaltungstyp_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungsTypFelderFehlerAction(error, x.veranstaltungstyp_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenQueryService);
        }
        return this.service;
    }
}
